import {
  HeadingText,
  ImageMessage,
  Modal,
  ParagraphText,
  queryHelpers,
  StackLayout,
  useMediaQuery,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import confirmClose from 'assets/confirm-close.svg';
import { BaseModalContainer } from 'components/modals/common/base-modal.component';
import { ModalActionButton } from 'components/modals/common/modal-action-button.component';

type BookAppointmentConfirmCloseModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const BookAppointmentConfirmCloseModal = ({
  isOpen,
  onCancel,
  onConfirm,
}: BookAppointmentConfirmCloseModalProps) => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery(queryHelpers.only('mobile'));

  return (
    <Modal.Root open={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <BaseModalContainer
        footer={
          <StackLayout
            horizontalAlignment={{ '@initial': 'end', '@mobile': 'center' }}
            orientation={{
              '@initial': 'horizontal',
              '@mobile': 'vertical',
            }}
            spacing="$one"
            css={{
              flexGrow: 0,
              '@mobile': {
                flexFlow: 'column-reverse',
              },
            }}
          >
            <ModalActionButton
              actionType="cancel"
              isMobile={isMobile}
              buttonText={formatMessage({ id: 'STR_CANCEL' })}
              css={{ color: '$secondaryTextDefault' }}
            />
            <ModalActionButton
              actionType="submit"
              isMobile={isMobile}
              destructive
              buttonText={formatMessage({ id: 'STR_YES_EXIT' })}
              onClick={onConfirm}
            />
          </StackLayout>
        }
      >
        <ImageMessage
          image={confirmClose}
          css={{
            flexGrow: 1,
            padding: '$two $none',
            textAlign: 'left',
            '@mobile': { padding: '$half' },
          }}
        >
          <HeadingText level="3" size="lg" css={{ paddingBlock: '$half' }}>
            {formatMessage({ id: 'STR_EXIT_BOOK_APPOINTMENT_TITLE' })}
          </HeadingText>
          <ParagraphText>
            {formatMessage({ id: 'STR_EXIT_BOOK_APPOINTMENT_BODY' })}
          </ParagraphText>
        </ImageMessage>
      </BaseModalContainer>
    </Modal.Root>
  );
};
